.rootLabel {
  margin-right: var(--tuna-spacing-1);
}

.buttonGroupWrap {
  flex-wrap: wrap;
  flex: 1;
}

.noteButton {
  text-transform: none;
  padding: 0;
}

.noneButton {
  text-transform: none;
  padding: 0;
  padding-left: var(--tuna-spacing-1);
  padding-right: var(--tuna-spacing-1);
}

.rootRow {
  margin-top: var(--tuna-spacing-1);
  gap: var(--tuna-spacing-2);
  display: flex;
}

.scaleTypeSelect {
  min-width: 200px;
  position: relative;
}
